<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="backmatter">
<header>
<h1 class="topictitle1" id="ac67"><a href="#/nav#nac67"><span class="title">Acknowledgments</span></a></h1>
</header>
<p>The author wishes to thank Michael Colleary and Mike Werb for their expert analysis and suggestions. For their enthusiasm
            and support, he thanks Lawrence Bender, Caren Bohrman, Mike Dobson, and Janet Jeffries. Thanks also to Ann Howard Creel, Robb
            McCaffree, and Robert Rodi for their careful reading of the manuscript. Special thanks to Dr. Edward O. Wilson, the Second
            Darwin, for his magnificent contributions to science.
         </p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?88e44b12